import { render, staticRenderFns } from "./cgm-week-activity.vue?vue&type=template&id=5265b80a&scoped=true&"
import script from "./cgm-week-activity.vue?vue&type=script&lang=js&"
export * from "./cgm-week-activity.vue?vue&type=script&lang=js&"
import style0 from "./cgm-week-activity.vue?vue&type=style&index=0&id=5265b80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265b80a",
  null
  
)

export default component.exports